class Gallery {

  constructor(mainImage, thumbnails, thumbnailsWrapper, captionArea = '', arrows = '', zoom = '') {
    this.total = 0;
    this.currentIndex = 1;
    this.thumbnails = thumbnails;
    this.cachedThumbnails = thumbnails;
    this.thumbnailsWrapper = thumbnailsWrapper;
    this.mainImage = mainImage;
    this.currentImage = mainImage.src;
    this.captionArea = captionArea ? captionArea : '';
    this.currentCaption = captionArea ? captionArea.innerHTML : '';
    this.arrows = arrows ? arrows : '';
    this.mainImageParent = this.mainImage.parentElement;
    this.backgroundImages = this.mainImageParent.style.backgroundImage ? true : false;
    this.zoomElement = zoom ? zoom : '';
    this.zoomStatus = false;

    this.setup();
  }

  setup() {
    this.total = parseInt(this.cachedThumbnails.length);
    
    this.handler();

    // remove currentindex from thumbnails
    this.thumbnails = Object.values(this.cachedThumbnails).filter((e,k) => k !== this.currentIndex - 1);


    this.render();
  }


  handler() {
    // Set Click Events on thumbnails
    this.thumbnails.forEach(item => {
      const media = item.querySelector('.js-media');

      if (!media) return;

      media.addEventListener('click', (e) => {
        // New ID
        let newID = item.dataset.index;
        let newImage = media.dataset.large;
        
        this.currentImage = newImage;
        this.currentIndex = parseInt(newID);
        
        if (this.captionArea) {
          let newCaption = media.dataset.caption;
          this.currentCaption = newCaption;
        }

        this.thumbnails = Object.values(this.cachedThumbnails).filter((e,k) => k !== this.currentIndex - 1);
        this.render();
      });
    });

    // Click events and arrows
    if (this.arrows) {
      this.arrows.forEach(arrow => {
        arrow.addEventListener('click', () => {
          let newID = '';

          if (arrow.classList.contains('js-gallery-next')) {
            newID = (this.currentIndex + 1) == this.total + 1 ? 1 : this.currentIndex + 1;
          } else {
            newID = (this.currentIndex - 1) == 0 ? this.total : this.currentIndex - 1;
          }

          let newElement = this.cachedThumbnails[newID - 1];
          const media = newElement.querySelector('.js-media');

          let newImage = media.dataset.large;
          
          this.currentImage = newImage;
          this.currentIndex = newID;
          
          if (this.captionArea) {
            let newCaption = media.dataset.caption;
            this.currentCaption = newCaption;
          }

          this.thumbnails = Object.values(this.cachedThumbnails).filter((e,k) => k !== this.currentIndex - 1);
          this.render();
        });
      });
    }

    if (this.zoomElement) {
      this.zoomElement.addEventListener('click', () => {
        this.zoomStatus = !this.zoomStatus;

        this.zoomElement.classList.toggle('isZoom');

        if (this.zoomStatus == true) this.triggerZoom();
      });
    }
  }


  render() {  
    // Set New Image
    this.mainImage.src = this.currentImage;

    // Resest Zoom
    if (this.zoomElement) {
      this.zoomElement.classList.remove('isZoom');
      this.zoomStatus = false;
    }

    if (this.backgroundImages) {
      this.mainImageParent.style.backgroundImage = `url(${this.currentImage})`;
    }

    if (this.captionArea) {
      this.captionArea.innerHTML = this.currentCaption;
    }

    // Reset
    this.thumbnailsWrapper.innerHTML = '';

    this.thumbnails.forEach(thumbnail => {
      this.thumbnailsWrapper.append(thumbnail);
    });
  }

  triggerZoom() {
    if (this.zoomElement && this.zoomStatus) {
      this.zoomElement.addEventListener('mousemove', (e) => {
        var zoomer = e.currentTarget;
        var offsetX = 0;
        var offsetY = 0;
        var x = 0;
        var y = 0;
        
        e.offsetX ? offsetX = e.offsetX : offsetX = e.touches.length ? e.touches[0].pageX : 0
        e.offsetY ? offsetY = e.offsetY : offsetX = e.touches.length ? e.touches[0].pageX : 0
        x = offsetX/zoomer.offsetWidth*100
        y = offsetY/zoomer.offsetHeight*100
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
      });
    }
  }
}


export default Gallery;